var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyCartIlmorrOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "#615e5c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2188 15C29.7188 15 30.0625 15.4688 29.9688 15.9375L28.5625 22.4375C28.4688 22.7812 28.1875 23 27.8125 23H18.0625L18.3438 24.5H27.1562C27.6562 24.5 28 24.9688 27.9062 25.4375L27.875 25.5625C28.25 25.9375 28.5 26.4375 28.5 27C28.5 28.125 27.5938 29 26.5 29C25.375 29 24.5 28.125 24.5 27C24.5 26.6562 24.5938 26.3125 24.75 26H20.2188C20.375 26.3125 20.5 26.6562 20.5 27C20.5 28.125 19.5938 29 18.5 29C17.375 29 16.5 28.125 16.5 27C16.5 26.4688 16.6875 26 17.0312 25.625L14.875 14.5H12.375C12.1562 14.5 12 14.3438 12 14.125V13.375C12 13.1875 12.1562 13 12.375 13H15.5C15.8438 13 16.1562 13.2812 16.2188 13.625L16.5 15H29.2188ZM18.5 27.75C18.9062 27.75 19.25 27.4375 19.25 27C19.25 26.5938 18.9062 26.25 18.5 26.25C18.0625 26.25 17.75 26.5938 17.75 27C17.75 27.4375 18.0625 27.75 18.5 27.75ZM26.5 27.75C26.9062 27.75 27.25 27.4375 27.25 27C27.25 26.5938 26.9062 26.25 26.5 26.25C26.0625 26.25 25.75 26.5938 25.75 27C25.75 27.4375 26.0625 27.75 26.5 27.75ZM27.2188 21.5L28.3125 16.5H16.7812L17.75 21.5H27.2188Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCartIlmorrOrder);
export default __webpack_public_path__ + "static/media/greyCartIlmorrOrder.ff4d0be08cb7e4e2b5ac7b65546c1b69.svg";
export { ForwardRef as ReactComponent };